import Button from 'jd-library/Button';
import historyHandler from 'jd-library/historyHandler';
import Modal from 'jd-library/Modal'
import React, { useState } from 'react'
import styles from "./add-edit-product.scss";
import { isSafari } from '../../utills';

export const DocReqModel = (props) => {
  const [isScrolled, setScrolled] = useState(false)
  const showGotItButton = ['CONTRACTOR', 'CONTRACTORV2', 'OBE'].includes(props.user); 
  const scrollHandler = (e) => {
    setScrolled(e.target.scrollTop > 5);
  }
  
    return (
        <Modal
        settings={{
          modalId: "DocReqProduct",
          variant: "action",
          class: styles["document-required-modal"],
        }}
        backdropStatic={true}
        onHidden={props.onHidden}
      >
        {/* <Modal.CloseIcon /> */}
        <div className={styles["document-required-body"]}>
          <div className={styles["heading"]}>
            Document Upload Required
          </div>
          <div className={`${styles['document-required-message']} ${isScrolled ? styles['scrolled'] : ''}`}>
          Following documents are required to showcase this product online
          </div>
          <div className={`${styles['scroll-container']} `}  onScroll={(e) => {scrollHandler(e);}}>
            {props.requireddocs?.length > 0 ? props.requireddocs?.map((item,index)=>{
                return (<div key={index} className={`${styles['message-box']}`}>
                          <div>
                            <span className={`${styles['bullet-mark']}`}></span>
                          </div>
                          <div className={`${styles['docs-required']}`}>
                            {/* {item +' for displaying this product. please go to the Update Documents section to upload it.'} */}
                            {item}
                          </div>
                        </div>)
            }) : null}
          </div>
        </div>
        <div className={styles["document-required-btn"]}>
          {!showGotItButton ? <Button
            size="lg"
            block
            clickHandler={() => {
              if(props.isMobile){
                 historyHandler.closeCurrent();
                 let safari = isSafari();
                 if((!props.isChrome && safari) || props.isIphone) {
                    setTimeout(() => {
                      historyHandler.closeCurrent();
                    }, 100);
                 }
              }           
              props.gotClicked({redirect:true,tabKey: 'documentPending'})
            }}
          >
            {"Upload Documents"}

          </Button> : null}
            <br/>
            <br/>
          <Button
            size="lg"
            block
            clickHandler={() => {
              props.gotClicked({redirect:false,tabKey: 'documentPending'})
            }}
          >
            {showGotItButton ? "Okay, Got it" : "Continue without Uploading"}
          </Button>
        </div>
      </Modal>
    )
}
